import _ from 'lodash'
import { createSelector } from 'reselect'

export const getHealthToppingPlans = (state) => _.get(state, 'selectedDisplayProduct.plans', [])

export const getSelectCampaignPlan = (state) => _.get(state, 'selectedDisplayProduct.selectedCampaignPlan', '')

export const getHealthToppingOptionsPlans = createSelector(getHealthToppingPlans, (plans) => {
  return plans.map((v) => ({
    text: v.name,
    value: v.planCode,
  }))
})
